export default "__VITE_ASSET__CUbVQzEN__"